import { connect } from "react-redux";
import get from "lodash/get";

import {
  getlogisiticGroups as onGetlogisiticGroups,
  createLogisiticGroups as onCreateLogisiticGroups,
  deleteLogisiticGroups as onDeleteLogisiticGroups,
  createControlPointLogisiticGroups as onCreateControlPointLogisiticGroups,
  deletelControlPointLogisiticGroups as onDeletelControlPointLogisiticGroups,
  selectLogisticGroup as onSelectLogisticGroup,
} from "./../../actions/logisticGroupsActions";

const mapStateToProps = (state) => ({
  logisticGroupsDataState: state.logisticGroups.logisticGroupsDataState,
  logisticCreateGroupDataState: state.logisticGroups.logisticCreateGroupDataState,
  logisticDeleteGroupDataState: state.logisticGroups.logisticDeleteGroupDataState,
  logisticCreateControlPointGroupDataState: state.logisticGroups.logisticCreateControlPointGroupDataState,
  logisticDeleteControlPointGroupDataState: state.logisticGroups.logisticDeleteControlPointGroupDataState,
  logisticGroups: get(state, ["logisticGroups", "logisticGroups"], []),
  logisticGroupFilters: get(state, ["logisticGroups", "logisticGroupFilters"], []),
  logisticSelectedGroup: get(state, ["logisticGroups", "logisticSelectedGroup"], null),
});

const mapDispatchToProps = {
  onGetlogisiticGroups,
  onCreateLogisiticGroups,
  onDeleteLogisiticGroups,
  onCreateControlPointLogisiticGroups,
  onDeletelControlPointLogisiticGroups,
  onSelectLogisticGroup,
};

const withLogisticGroups = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withLogisticGroups };
